import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"
import { mutate } from "lib/graphql/mutate"

const FIELDS = gql`
    fragment ScimBreakerDetail on ScimCircuitBreakerStatus {
        tripped
        trippedAt
        reason
        deprovisionsInWindow
        windowMinutes
        thresholdPercent
        thresholdAbsolute
        minActiveForPercent
        breakerMaxDeprovisions
        breakerDisabled
    }
`

export const getScimCircuitBreakerDetail = api(async function getScimCircuitBreaker({ clientId } = {}) {
    return await query(
        gql`
            ${FIELDS}
            query getScimCircuitBreaker($clientId: String) {
                getScimCircuitBreaker(clientId: $clientId) {
                    ...ScimBreakerDetail
                }
            }
        `,
        { clientId },
        { returns: "getScimCircuitBreaker", fetchPolicy: "network-only" }
    )
})

export const setScimBreakerOverride = api(async function setScimBreakerOverride({
    clientId,
    breakerMaxDeprovisions,
    breakerDisabled,
} = {}) {
    return await mutate(
        gql`
            ${FIELDS}
            mutation setScimBreakerOverride(
                $clientId: String
                $breakerMaxDeprovisions: Int
                $breakerDisabled: Boolean
            ) {
                setScimBreakerOverride(
                    clientId: $clientId
                    breakerMaxDeprovisions: $breakerMaxDeprovisions
                    breakerDisabled: $breakerDisabled
                ) {
                    ...ScimBreakerDetail
                }
            }
        `,
        { clientId, breakerMaxDeprovisions, breakerDisabled },
        { returns: "setScimBreakerOverride" }
    )
})
